// extracted by mini-css-extract-plugin
export default {"con-table":"ukOrdqry"};